/*
 * Avada's Consent Mode messages pass through this gtag. A visitor who has
 * opted out of the sale or sharing of their data (Avada's "Do not Sell or
 * Share" checkbox, Shopify's sale-of-data record, or Global Privacy Control)
 * must not have ad_user_data or ad_personalization granted, even after
 * accepting marketing cookies — Avada grants them on Accept regardless. The
 * GTM loader (snippets/gtm-consent-loader.liquid) applies the same rule.
 */
function saleOfDataOptedOut() {
  try {
    if (navigator.globalPrivacyControl === true) return true;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.saleOfDataAllowed === "function" && privacy.saleOfDataAllowed() === false) return true;
    var avada = getCookie("avada_cookie_consent");
    if (avada && avada.sale_of_data === false) return true;
  } catch (e) {}
  return false;
}
function gtag() {
  var args = Array.prototype.slice.call(arguments);
  if (args[0] === "consent" && args[2] && saleOfDataOptedOut()) {
    args[2] = Object.assign({}, args[2], { ad_user_data: "denied", ad_personalization: "denied" });
  }
  // Google only reads commands pushed as an `arguments` object.
  (function () {
    window.dataLayer.push(arguments);
  }).apply(null, args);
}
function getCookie(e) {
  const t = e + "=",
    a = document.cookie.split(";");
  for (let e = 0; e < a.length; e++) {
    let n = a[e];
    for (; " " === n.charAt(0); ) n = n.substring(1, n.length);
    if (0 === n.indexOf(t))
      return JSON.parse(decodeURIComponent(n.substring(t.length, n.length)));
  }
  return {};
}
const features = [{ name: "consent-tracking-api", version: "0.1" }];
(window.dataLayer = window.dataLayer || []),
  (window.AVADA_COOKIES_BAR = window.AVADA_COOKIES_BAR || {}),
  (window.AVADA_COOKIE_CONSENT = getCookie("avada_cookie_consent")),
  window.Shopify?.loadFeatures &&
    window.Shopify.loadFeatures(features, (e) => {
      e && console.error("Failed to load features", e);
    }),
  (() => {
    let e = window.AVADA_COOKIE_CONSENT;
    if (!Object.keys(e).length) {
      const t =
        !window.Shopify?.customerPrivacy ||
        window.Shopify.customerPrivacy.shouldShowBanner();
      e = { marketing: !t, analytics: !t, functional: !t };
    }
    !e.marketing && gtag("set", "ads_data_redaction", !0),
      gtag("set", "url_passthrough", !0),
      gtag("default", {
        ad_storage: e.marketing ? "granted" : "denied",
        ad_user_data: e.marketing ? "granted" : "denied",
        ad_personalization: e.marketing ? "granted" : "denied",
        analytics_storage: e.analytics ? "granted" : "denied",
        functionality_storage: e.functional ? "granted" : "denied",
        personalization_storage: e.functional ? "granted" : "denied",
        security_storage: "granted",
        wait_for_update: 500,
      });
  })();
